import {Canvas} from "@react-three/fiber"
import {KeyboardControls, PointerLockControls, Sky} from "@react-three/drei"
import {Physics} from "@react-three/rapier"
import {Player} from "./Player"
import "./Minecraft.css"

import {useEffect} from "react";
import Hotkeys from "react-hot-keys";


export default function Minecraft() {

    useEffect(() => {
        const originalBodyClassName = document.body.className
        document.body.className = `${originalBodyClassName} minecraft-html-body-root minecraft-body`

        const root = document.getElementById('root')
        const originalRootClassName = root!.className
        root!.className = `${originalRootClassName} minecraft-html-body-root`

        return () => {
            document.body.className = originalBodyClassName
            root!.className = originalRootClassName
        }
    }, [])


    return (
        <Hotkeys keyName={'ctrl+d'}
                 onKeyDown={(shortcut, evn, handle) => {
                     alert('ctrl+d')
                     evn.preventDefault();
                 }}>
            <KeyboardControls
                map={[
                    {name: "forward", keys: ["ArrowUp", "w", "W"]},
                    {name: "backward", keys: ["ArrowDown", "s", "S"]},
                    {name: "left", keys: ["ArrowLeft", "a", "A"]},
                    {name: "right", keys: ["ArrowRight", "d", "D"]},
                    {name: "jump", keys: ["Space"]},
                    {name: "sprint", keys: ["ShiftLeft", "ShiftRight"]},
                    {name: "tenth", keys: ["Digit0"]},
                    {name: "first", keys: ["Digit1"]},
                    {name: "second", keys: ["Digit2"]},
                    {name: "third", keys: ["Digit3"]},
                    {name: "fourth", keys: ["Digit4"]},
                    {name: "fifth", keys: ["Digit5"]},
                    {name: "sixth", keys: ["Digit6"]},
                    {name: "seventh", keys: ["Digit7"]},
                    {name: "eighth", keys: ["Digit8"]},
                    {name: "ninth", keys: ["Digit9"]},
                ]}>
                <Canvas shadows camera={{fov: 70}}>
                    <Sky sunPosition={[100, 20, 100]}/>
                    <ambientLight intensity={0.3}/>
                    <pointLight castShadow intensity={0.8} position={[100, 100, 100]}/>
                    <Physics gravity={[0, -30, 0]}>
                        <Player/>
                    </Physics>
                    <PointerLockControls/>
                </Canvas>
            </KeyboardControls>
        </Hotkeys>
    )
}
